// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1AhYS071","content":"-hRJBQib","image-container":"_3hGCQw0L","details-container":"_3FS88QMU","imgCol":"_26uMxggG","image":"_3L5iL_9l","col2":"rDjnEAXp","scrollLink":"yHD3V5Rs","back":"_18XxAjMp","blackBar":"_3S3Ich3t","next-button":"sXYUNejX"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/AsideThumbBanner/AsideThumbBanner.styl
// module id = 225
// module chunks = 0